module.exports = __webpack_public_path__ + "img/buscar.695a3160.svg";